import { configureRideHealthNotes } from 'src/components/Contacts/components/useRideHealth';
import { find, get } from 'lodash';

export const getDurationDisplayName = (durations, durationValue) => get(
  find(durations, (duration) => Number(duration.value) === durationValue),
  'display_name',
);

export const getUpdatedNotes = (notes, rideHealthConfig) => {
  const hasRideHealthNotes = rideHealthConfig && notes.some((note) => note.text.includes('Ride Health ID:'));

  return hasRideHealthNotes ? configureRideHealthNotes(notes, rideHealthConfig) : notes;
};

export const getDisplayNotes = (notes, isClientsDrawer) => (
  isClientsDrawer ? notes.slice(0, 3) : notes
);
